import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';



class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 30000;
    }

    // Login Page
    signUp = (request) =>{
        return  axios.post( 'sign-up', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }



    //Orders History Page
    getOrders = (params = null) => {
        return axios.get( `orders`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Order  Detail  Page
    getOrder = (params = null , id) => {
        return axios.get( `orders/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateStatus = (request) =>{
        return  axios.patch( 'update-order-status', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    storeScore = (request) =>{
        return  axios.patch( 'store-score', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Vendor Page
    getVendor = (params = null) => {
        return axios.get( `products/vendors/supplier`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Vendor Page
    getVendor2 =  (id,params) => {
        return axios.get( `products/vendors/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getProduct = (params = null , id) => {
        return axios.get( `products/products/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    storeVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/vendors', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/update-vendor', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    updateProduct = (request, id) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( `products/update-product/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    updateProductPrice = (request, id) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( `products/update-product-price/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    insertProduct = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( `products/products`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getProductGroups = (params) => {
        return axios.get( `products/groups`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getCountUnit = (params) => {
        return axios.get( `constants/count-units`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    editOrder = (request,id) =>{
        return  axios.put( `orders/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getReport = (params = null , id) => {
        return axios.get( `vendor-reports`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getProductReport = (params = null , id) => {
        return axios.get( `vendor-products-reports`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getStates = (params = null) => {
        return axios.get( `locations/states`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getCities = (params = null) => {
        return axios.get( `locations/cities`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getAreas = (params = null) => {
        return axios.get( `locations/areas`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getVendorAreas = (vid, params = null) => {
        return axios.get( `locations/vendor-areas/${vid}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    addVendorAreas = (vid, request = null) => {
        return axios.post( `locations/vendor-areas/${vid}`, request,{
            headers,

        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    deleteVendorAreas = (vid, id, params = null) => {
        return axios.delete( `locations/vendor-areas/${vid}/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getWalletDetail = (params = null) => {
        return axios.get( `wallets/transactions`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    searchProducts = (params = null) => {
        return axios.get( `products/search`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;